export default {"src":"/_next/static/media/twitter.744a9e56.svg","height":292,"width":323,"blurWidth":0,"blurHeight":0};